"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAgendaSlotsBookedStatsListApiResponseSchema = exports.getAgendaSlotBookedStatItemApiSchema = exports.slotStatMonths = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.slotStatMonths = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
];
exports.getAgendaSlotBookedStatItemApiSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('agenda-slots-stats'),
    attributes: zod_1.z.object({
        month: zod_1.z.enum(exports.slotStatMonths),
        year: zod_1.z.number(),
        confirmed: zod_1.z.number(),
        toValidate: zod_1.z.number(),
    }),
});
exports.getAgendaSlotsBookedStatsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getAgendaSlotBookedStatItemApiSchema);
